import { ArrowRight, Fish, Zap } from "lucide-react";
import { PRODUCTS } from "@/data/products";
import ProductImage from "@/components/ProductImage";

const CARDS = [
  { category: "Fishing Reels", icon: Fish, blurb: "Baitcasting and overhead jigging reels from Daiwa and Shimano." },
  { category: "Electric Reels", icon: Zap, blurb: "Daiwa Seaborg electric reels for deep-water fishing." },
  { category: "Fishing Rods", icon: Fish, blurb: "Rods from Fenwick, Bombada, Major Craft, SMITH and Douglas." },
];

function cardImage(category) {
  const withImage = PRODUCTS.find((p) => p.category === category && p.image);
  if (withImage) return withImage;
  return PRODUCTS.find((p) => p.category === category);
}

export default function Categories({ onSelect }) {
  return (
    <section className="bg-cream py-16 sm:py-20" aria-label="Product categories">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <h2 className="font-display text-3xl font-semibold text-charcoal sm:text-4xl">
          Shop by Category
        </h2>
        <p className="mt-3 max-w-2xl text-sm text-charcoal/70 sm:text-base">
          Reels, electric reels and rods — every listing shows its own condition
          and price in Malaysian Ringgit.
        </p>
        <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {CARDS.map((card) => {
            const product = cardImage(card.category);
            const Icon = card.icon;
            return (
              <button
                key={card.category}
                type="button"
                onClick={() => onSelect(card.category)}
                className="group overflow-hidden rounded-2xl border border-charcoal/10 bg-white text-left shadow-sm transition-shadow hover:shadow-xl"
                data-testid={`category-card-${card.category.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="aspect-[4/3] overflow-hidden">
                  {product && product.image ? (
                    <ProductImage product={product} className="h-full w-full" />
                  ) : (
                    <div className="flex h-full w-full flex-col items-center justify-center gap-3 bg-forest/5">
                      <Icon className="h-10 w-10 text-forest" aria-hidden="true" />
                      <span className="font-display text-lg text-forest">{card.category}</span>
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="font-display text-xl font-semibold text-charcoal">
                    {card.category}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-charcoal/65">{card.blurb}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-bronze-dark transition-colors group-hover:text-bronze">
                    Browse {card.category}
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" />
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
